// extracted by mini-css-extract-plugin
export default {"host":"UserProfileIcon_host__BzwWh","hostEmpty":"UserProfileIcon_hostEmpty__8rO5V"};